<template>
  <div class="import-client">
    <div class="import-client__heading">
      <AkParagraph
        v-if="getNewContacts === 0"
        class="import-client__text import-client__text--no-margin import-client__text--bold"
      >
        {{ $t('All these contacts are already in your network') }}
      </AkParagraph>
      <i18n-t
        v-if="getNewContacts === 1"
        data-testid="resultImportClients"
        keypath="{number} contact has been {message} to your network"
        class="import-client__text import-client__text--no-margin import-client__text--bold"
        tag="p"
      >
        <template #number>
          {{ getNewContacts }}
        </template>
        <template #message>
          <span class="import-client__text import-client__text--accent-alt">{{
            $t('successfully added | successfully added | successfully added', getNewContacts)
          }}</span>
        </template>
      </i18n-t>
      <i18n-t
        v-if="getNewContacts > 1"
        data-testid="resultImportClients"
        keypath="{number} contacts have been {message} to your network"
        class="import-client__text import-client__text--no-margin import-client__text--bold"
        tag="p"
      >
        <template #number>
          {{ getNewContacts }}
        </template>
        <template #message>
          <span class="import-client__text import-client__text--accent-alt">{{
            $t('successfully added | successfully added | successfully added', getNewContacts)
          }}</span>
        </template>
      </i18n-t>
    </div>
    <div class="import-client__content">
      <div class="import-client__highlight">
        <AkParagraph class="import-client__text import-client__text--no-margin">
          {{ $t('brand.network.importClients.shareShopLink') }}
        </AkParagraph>
      </div>
    </div>
    <div class="import-client__footer">
      <AkButton
        size="lg"
        data-testid="backToNetworkBtn"
        color="white"
        outlined
        @click="closeParentPopin('brand_cant_invite')"
      >
        {{ $t('Back to My network') }}
      </AkButton>
      <AkButton
        v-if="getNewContacts > 0 && !invitesSent"
        size="lg"
        data-testid="sendInvitationBtn"
        @click="changeStep"
      >
        {{ $t('brand.network.importClients.sendInvitation') }}
      </AkButton>
    </div>
  </div>
</template>
<script lang="ts">
import Analytics from '@monolith/legacy/services/analytics';
import { BrandClickedEvent } from '@monolith/legacy/services/analytics/events/brand-clicked.event';
import { BrandClickOrigin, BrandClickAction } from '@monolith/legacy/types/analytics/brand-click-event';
import { mapGetters } from 'vuex';

import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ImportClientsStepNoResult',
  props: {
    getNewContacts: {
      type: Number,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    response: {
      type: Object,
      required: true,
    },
    invitesSent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['validateStep', 'closePopin'],
  computed: {
    ...mapGetters(['brand']),
  },
  methods: {
    changeStep() {
      this.$emit('validateStep');
      Analytics.track(
        new BrandClickedEvent({
          brand_id: this.brand.id,
          origin: BrandClickOrigin.ImportClientsConfirmation,
          action: BrandClickAction.BrandStartInvitation,
        })
      );
    },
    closeParentPopin(actionName) {
      Analytics.track(
        new BrandClickedEvent({
          brand_id: this.brand.id,
          origin: BrandClickOrigin.ImportClientsConfirmation,
          action: actionName == 'brand_do_it_later' ? BrandClickAction.BrandDoItLater : BrandClickAction.BrandCantInvite,
        })
      );
      this.$emit('closePopin');
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@css/vue-import';

.import-client {
  &__heading {
    @apply ds-bg-primary ds-text-white ds-p-5 ds-text-left;
  }
  &__text {
    @apply ds-text-base;
    &--no-margin {
      @apply ds-mb-0;
    }
    &--bold {
      @apply ds-font-bold;
    }
    &--accent-alt {
      @apply ds-text-accent-alt;
    }
  }
  &__content {
    @apply ds-p-5 ds-text-left ds-overflow-y-auto;
  }
  &__footer {
    @apply ds-px-5 ds-py-4;
    @apply ds-border-t ds-border-solid ds-border-neutral-300;
    @apply ds-flex ds-items-center ds-justify-end ds-flex-row ds-gap-4;
  }
  &__highlight {
    @apply ds-bg-warm-white ds-p-4 ds-rounded-md ds-text-center;
    &--legend {
      @apply ds-mt-2 ds-mb-0;
      @apply ds-text-neutral-700;
    }
  }
  &__bg {
    &--send {
      @apply ds-bg-center ds-bg-no-repeat ds-bg-contain ds-h-9;
      background-image: url(/images/network/contacts-eligible.svg);
      background-size: 80px;
    }
  }
  form {
    @apply ds-mb-0;
    label {
      @apply ds-text-base;
    }
    textarea {
      @apply ds-w-full ds-block ds-border ds-border-solid ds-border-neutral-300;
      &::placeholder {
        @apply ds-text-neutral-700;
      }
    }
  }
  .form-single {
    @apply ds-mb-6;
  }
}

.errors {
  @apply ds-text-error-700;
  margin-bottom: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
}
</style>
